import BaseComponent from '../base_component/base_component'

export default class Confirmation extends BaseComponent {
    result: boolean;

    constructor(id: number, component_name: string, options: any) {
        super(id, component_name, options);
    }

    ok(){
        getComponent('modal').close();
        this.result = true;
    }

    cancel(){
        getComponent('modal').close();
        this.result =  false;
    }

    getConfirmationResult(){
        return this.result;
        // return 5;
    }

    functions() {
        return {
            getConfirmationResult: () => this.getConfirmationResult()
        }
    }
}